import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function ProductVisual() {
  return <section className="py-24 bg-hubble-ink relative z-10" data-id="element-165">
      <div className="max-w-5xl mx-auto px-6" data-id="element-166">
        <div className="text-center mb-12" data-id="element-167">
          <span className="text-hubble-signal text-[12px] md:text-[14px] font-body font-medium tracking-[3px] uppercase block" data-id="element-168">
            SEE IT WORK
          </span>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="rounded-2xl border border-hubble-border bg-hubble-card overflow-hidden shadow-2xl" data-id="element-169">
          {/* Mockup Header */}
          <div className="h-12 border-b border-hubble-border bg-hubble-ink flex items-center px-4 gap-2" data-id="element-170">
            <div className="flex gap-1.5" data-id="element-171">
              <div className="w-3 h-3 rounded-full bg-hubble-border" data-id="element-172"></div>
              <div className="w-3 h-3 rounded-full bg-hubble-border" data-id="element-173"></div>
              <div className="w-3 h-3 rounded-full bg-hubble-border" data-id="element-174"></div>
            </div>
            <div className="mx-auto font-body text-xs text-hubble-paper/40" data-id="element-175">
              Agent Tool Call Stream
            </div>
          </div>

          {/* Mockup Body */}
          <div className="p-6 md:p-10 font-body text-sm text-hubble-paper/70 space-y-6" data-id="element-176">
            <div className="flex gap-4" data-id="element-177">
              <div className="text-hubble-signal" data-id="element-178">→</div>
              <div data-id="element-179">
                <div className="text-hubble-paper mb-1" data-id="element-180">Patient lookup</div>
                <div className="font-mono text-xs text-hubble-paper/40" data-id="element-181">
                  Executing tool: get_patient_record
                </div>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-182">
              <div className="text-hubble-signal" data-id="element-183">→</div>
              <div data-id="element-184">
                <div className="text-hubble-paper mb-1" data-id="element-185">
                  Conditions and medications
                </div>
                <div className="font-mono text-xs text-hubble-paper/40" data-id="element-186">
                  Executing tool: get_patient_medications
                </div>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-187">
              <div className="text-hubble-signal" data-id="element-188">→</div>
              <div data-id="element-189">
                <div className="text-hubble-paper mb-1" data-id="element-190">
                  Eligibility check against UnitedHealthcare
                </div>
                <div className="font-mono text-xs text-hubble-paper/40" data-id="element-191">
                  Executing tool: check_patient_eligibility
                </div>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-192">
              <div className="text-hubble-signal" data-id="element-193">✓</div>
              <div className="bg-hubble-ink border border-hubble-border rounded-lg p-4 w-full" data-id="element-194">
                <div className="text-hubble-paper mb-2 font-medium" data-id="element-195">
                  Structured result
                </div>
                <div className="font-mono text-xs text-hubble-signal" data-id="element-196">
                  {`{
  "status": "active",
  "diagnosis": "E11.9",
  "medication": "Metformin 500mg",
  "coverage": "in-network confirmed"
}`}
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        <p className="text-center font-body text-[15px] text-hubble-paper/50 mt-8 max-w-2xl mx-auto" data-id="element-197">
          A single agent pulls patient context, runs an eligibility check, and
          returns a structured result. One platform underneath.
        </p>

        <div className="flex justify-center mt-10" data-id="element-198">
          <Button variant="primary" size="lg" onClick={() => window.open('https://calendly.com/prabha-hubble/30min?month=2026-04', '_blank')} data-id="element-199">
            Book a Demo
          </Button>
        </div>
      </div>
    </section>;
}